// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/general-ledger-accounts/archive',
        component: () =>
            import('@/pages/[organisation]/accounting/general-ledger-accounts/archive.vue'),
        name: 'accounting.general-ledger-accounts.archived-general-ledger-accounts',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.general-ledger.update-general-ledger-account',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/general-ledger-accounts/archive/[id].vue'),
                name: 'accounting.general-ledger-accounts.view-archived-general-ledger-account',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.general-ledger.update-general-ledger-account',
                },
            },
        ],
    },

    {
        path: '/:organisation/accounting/general-ledger-accounts',
        component: () =>
            import('@/pages/[organisation]/accounting/general-ledger-accounts.vue'),
        name: 'accounting.general-ledger-accounts.search-general-ledger-accounts',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.general-ledger.view-general-ledger-accounts',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/accounting/general-ledger-accounts/new.vue'),
                name: 'accounting.general-ledger-accounts.create-general-ledger-account',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.general-ledger.create-general-ledger-account',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/general-ledger-accounts/[id].vue'),
                name: 'accounting.general-ledger-accounts.view-general-ledger-account',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.general-ledger.view-general-ledger-accounts',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/accounting/general-ledger-accounts/[id]/edit.vue'),
                name: 'accounting.general-ledger-accounts.update-general-ledger-account',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.general-ledger.update-general-ledger-account',
                },
            },
        ],
    },
];
